import React from "react";

export default function HeadquartersGrid({
  children,
  min = 190,
  gap = 16,
  style = {},
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fit, minmax(${min}px, 1fr))`,
        gap,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
